// CAPABILITIES
export const CAPABILITY_APM = 'APM';
export const CAPABILITY_BROWSER = 'BROWSER';
export const CAPABILITY_VM = 'VM';
export const CAPABILITY_DATABASE = 'DATABASE';
export const CAPABILITY_SM = 'SM';
export const CAPABILITY_A = 'A';
export const CAPABILITY_B = 'B';
export const CAPABILITY_M = 'M';
export const CAPABILITY_MOBILE = 'MOBILE';
export const CAPABILITY_WSM = 'WSM';
export const CAPABILITY_K8M = 'K8M';
export const CAPABILITY_INTEGRATIONS = 'INTEGRATIONS';
export const CAPABILITY_CLOUD = 'CAPABILITY_CLOUD';
export const CAPABILITY_LOG = 'LOG';
export const CAPABILITY_ANALYTICS = 'ANALYTICS';
export const CAPABILITY_DE = 'DE';
export const CAPABILITY_MQ = 'MQ';
export const CAPABILITY_USAGE = 'USAGE';
export const CAPABILITY_DBM = 'DBM';
export const CAPABILITY_HOME = 'HOME';
export const CAPABILITY_NOTIFICATION = 'NOTIFICATION';

// CORRELATED CAPABILITIES
export const CORRELATED_CAPABILITIES_APM = "V";

//SIDENAV TEMPLATES
export const TEMPLATE_NOTIFICATION = 'TEMPLATE_NOTIFICATION';
export const TEMPLATE_APM = 'TEMPLATE_APM';
export const TEMPLATE_BROWSER = 'TEMPLATE_BROWSER';
export const TEMPLATE_VM = 'TEMPLATE_VM';
export const TEMPLATE_ALERT = 'TEMPLATE_ALERT';
export const TEMPLATE_ALERTS_V2 = 'TEMPLATE_ALERTS_V2';
export const TEMPLATE_HOME = 'TEMPLATE_HOME';
export const TEMPLATE_SETTINGS = 'TEMPLATE_SETTINGS';
export const TEMPLATE_DATABASE = 'TEMPLATE_DATABASE';
export const TEMPLATE_SM = 'TEMPLATE_SM';
export const TEMPLATE_HELP = 'TEMPLATE_HELP';
export const TEMPLATE_MOBILE = 'TEMPLATE_MOBILE';
export const TEMPLATE_WSM = 'TEMPLATE_WSM';
export const TEMPLATE_K8M = 'TEMPLATE_K8M';
export const TEMPLATE_INTEGRATIONS = 'TEMPLATE_INTEGRATIONS';
export const TEMPLATE_CLOUD_SVC = 'TEMPLATE_CLOUD_SVC';
export const TEMPLATE_LOG = 'TEMPLATE_LOG';
export const TEMPLATE_ANALYTICS = 'TEMPLATE_ANALYTICS';
export const TEMPLATE_DE = 'TEMPLATE_DE';
export const TEMPLATE_BILLING_USAGE = 'TEMPLATE_BILLING_USAGE';
export const TEMPLATE_MQ = 'TEMPLATE_MQ';
export const TEMPLATE_AWS = 'TEMPLATE_AWS';
export const TEMPLATE_USAGE = 'TEMPLATE_USAGE';
export const TEMPLATE_LOADING_PAGE = 'TEMPLATE_LOADING_PAGE';


export const COMPONENT_PAGES = 'Pages';

export const CLIENT_IP = 'clientIP';

export const FALLBACK_IP = '';

export const BW_APP_INDEX = 'browser_app_apdex';

export const SM_FALLBACK_IP = ['133.237.8.182', '133.237.8.181'];

export const DEFAULT_REF_INTERVAL = 'Off';

export const AUTO_REF_KEY = 'auto_ref';

// ALARM COMMON CONSTANT
export const ALARM_MAX_VALUE = 100000001;

// OTEL SPAN AND PARENT SPAN CONSTANTS
export const OTEL_PARENT_SPAN_ID = 'otel_parent_span_id';

export const OTEL_SPAN_ID = 'otel_span_id';
export const VIRTUAL_NODE = 'VirtualNode';

export const UNKNOWN_SERVER = 'unknown';

export const USER_READ_ONLY = 'USER';

export const USER = 'User';

// PAGE-SIZE FOR REXSELECTV3 PAGINATION

export const PAGE_SIZE_SCROLL = 20;

export const SELECT_FIELD_DEBOUNCE_DURATION_IN_MS = 1000;

export const SELECT_FIELD_THROTTLE_DURATION_IN_MS = 300;

export const FORECAST_PRIMARY_COLOR = 'rgba(4, 217, 255, 1)';

export const defaultValueMutations = [
  'apmState/apmCommonState/setDefaultValues',
  'browserState/browserCommonState/setDefaultValues',
  'databaseState/databaseCommonState/setDefaultValues',
  'mobileState/mobileCommonState/setDefaultValues',
  'wsmState/wsmCommonState/setDefaultValues',
  'vmState/vmCommonState/setDefaultValues',
  'syntheticState/secretManager/setDefaultValues',
  'syntheticState/tokenManager/setDefaultValues',
  'syntheticState/commonState/setDefaultValues',
  'syntheticState/endpoints/setDefaultValues',
  'mqState/mqCommonState/setDefaultValues',
  'logState/logCommonState/setDefaultValues',
  'k8State/k8CommonState/setDefaultValues',
  'homeState/setDefaultValues',
  'alertV2State/configure/setDefaultValues',
  'channelState/overview/setDefaultValues',
  'alertV2State/extTagGrouping/setDefaultValues',
  'alertV2State/tagGrouping/setDefaultValues',
  'cloudState/services/setDefaultValues',
  'databaseState/detail/setDefaultValues',
];
